import React from 'react';
import { Link, Smartphone, X } from 'lucide-react';

const ShareModal = ({ isOpen, onClose, onShare, review }) => {
  if (!isOpen) return null;

  const handleShare = (method) => {
    onShare(method);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center">
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      ></div>
      
      {/* Modal Content */}
      <div className="relative bg-white w-full max-w-md mx-4 rounded-t-3xl sm:rounded-2xl shadow-2xl">
        {/* Header */}
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900">Share Review</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
              aria-label="Close"
            >
              <X size={24} />
            </button>
          </div>
          <p className="text-sm text-gray-600 mt-1">
            "{review.sandwich.name}" at {review.restaurant.name}
          </p>
        </div>
        
        {/* Share Options */}
        <div className="p-4 space-y-3">
          {/* Copy Link */}
          <button
            onClick={() => handleShare('copy_link')}
            className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
              <Link size={24} className="text-blue-600" aria-hidden="true" />
            </div>
            <div className="text-left">
              <div className="font-medium text-gray-900">Copy Link</div>
              <div className="text-sm text-gray-500">Copy link to clipboard</div>
            </div>
          </button>
          
          {/* Native Share (if available) */}
          {typeof navigator !== 'undefined' && navigator.share && (
            <button
              onClick={() => handleShare('native_share')}
              className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <Smartphone size={24} className="text-green-600" aria-hidden="true" />
              </div>
              <div className="text-left">
                <div className="font-medium text-gray-900">Share</div>
                <div className="text-sm text-gray-500">Use device share menu</div>
              </div>
            </button>
          )}
        </div>
        
        {/* Cancel Button */}
        <div className="p-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="w-full py-3 text-gray-600 hover:text-gray-800 font-medium"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;


